export default __webpack_public_path__ + "static/media/4957.e65a0033.png";